import React from 'react';
import { Divider } from '../atoms';
import {exclametryred} from '../../../assets/images';
import { dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles';

const getContent = (sponsored, type, toggleHelp) => {
  if (['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role'))) {
    if (sponsored) {
      return (
        <div className='mt-6'>
          <Divider classes='w-full' />
          <p className='text-sm text-gray-800 mt-6 mb-0 italic'>
            To improve the utilization reach out to the marketing team for a customized plan & share it with the HR.
          </p>
        </div>
      );
    } else {
      return (
        <p className='text-base text-gray-800 mt-2 mb-0'>The {type} benefit is not sponsored for this organization</p>
      );
    }
  } else if (sponsored) {
    return (
      <div className='mt-2'>
        <p className='text-base text-gray-800 mb-8'>
          To increase the utilization, contact your <span className='font-semibold'>customer success manager</span>
        </p>
        <button
          type='button'
          onClick={toggleHelp}
          className={joinButtonClasses(dsButtonPrimary, 'h-10 px-6')}
        >
          Talk to CSM
        </button>
      </div>
    );
  }

  return null;
};

const LowUtilizationCard = ({ heading, body, imgsrc, type, sponsored, toggleHelp, classes = '' }) => {
  return (
    <div className={'mx-auto w-full max-w-3xl rounded-xl border border-gray-200 bg-white px-6 py-10 text-center shadow-sm sm:px-10 md:py-12 ' + classes}>
        <img src={imgsrc} className='inline-block' height={190} width={190} alt='image1' />
        <div className='flex items-center justify-center mt-8'>
          <img src={exclametryred} className='inline-block mr-2' height={30} width={30} alt='info-red' />
        <p className='mb-0 text-xl text-gray-900 font-semibold'>{heading}</p>
        </div>
        <p className='mt-6 mb-0 text-base text-gray-800'>{body}</p>
        {getContent(sponsored, type, toggleHelp)}
    </div>
  );
};

export default LowUtilizationCard;
